// Configuración del proxy backend
const PROXY_CONFIG = {
    baseUrl: process.env.REACT_APP_PROXY_URL || '',
    endpoint: '/api/newsletter/mailrelay/subscribers'
};

/**
 * Suscribir email al newsletter usando el proxy backend
 * @param {string} email - Email del suscriptor
 * @param {string} name - Nombre del suscriptor (opcional)
 * @returns {Promise<{success: boolean, data?: any, error?: string}>}
 */
export const subscribeToNewsletter = async (email, name = '') => {
    try {
        console.log('=== NEWSLETTER SUBSCRIPTION VIA PROXY ===');
        console.log('Email:', email);
        console.log('Name:', name || 'Not provided');
        console.log('Proxy URL:', `${PROXY_CONFIG.baseUrl}${PROXY_CONFIG.endpoint}`);
        
        const response = await fetch(`${PROXY_CONFIG.baseUrl}${PROXY_CONFIG.endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                name: name
            })
        });

        console.log('Proxy response status:', response.status);
        
        const data = await response.json();
        console.log('Proxy response data:', data);

        if (response.ok) {
            console.log('✅ Subscription successful');
            return {
                success: true,
                data: {
                    message: '¡Suscripción exitosa! Te mantendremos informado sobre nuestras nuevas publicaciones.',
                    email: email,
                    details: data
                }
            };
        } else {
            console.log('❌ Subscription failed:', data);
            return {
                success: false,
                error: data.error || 'Error en la suscripción'
            };
        }

    } catch (error) {
        console.error('=== SUBSCRIPTION ERROR ===');
        console.error('Error:', error);
        
        // Verificar si es un error de red/CORS
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
            return {
                success: false,
                error: 'Error de conexión. Por favor, verifica tu conexión a internet e intenta nuevamente.'
            };
        }
        
        return {
            success: false,
            error: 'Error inesperado. Por favor, intenta nuevamente.'
        };
    }
};

export default PROXY_CONFIG;